import React from "react";
import Marquee from "react-fast-marquee";
import { Container } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import { primaryColor, textLightColor } from "../../../../Constants/Colors";
import { useGetMarqueeDataQuery } from "../../../../redux/api/MarqueeApi/marqueeApi";
import ErrorAlert from "../../../../Components/ErrorAlert";

const MarqueeBanner = () => {
  const { data, error, isLoading } = useGetMarqueeDataQuery({
    limit: 100, // Fetch more records for the marquee banner
    status: true,
    sortBy: "display_order",
    order: "asc",
  });

  // Handle loading state
  if (isLoading) {
    return (
      <section
        style={{
          backgroundColor: primaryColor,
          color: textLightColor,
          padding: "60px 0",
        }}
      >
        <Container>
          <div className="text-center">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  // Handle error state
  if (error) {
    return (
      <>
        <ErrorAlert
          message="Unable to fetch marquees. Please try again later."
          iconSize={30}
        />
      </>
    );
  }

  // Extract marquees from the paginated response object
  const marquees = data?.marquees || [];

  // --- Handle empty data
  if (!marquees.length) {
    return null; // Don't show anything if no marquee content
  }

  // --- Main UI
  return (
    <div
      style={{
        backgroundColor: primaryColor,
        color: "#fff",
        padding: "10px 0",
      }}
    >
      <Container fluid>
        <Marquee gradient={false} speed={60} pauseOnHover>
          {marquees
            ?.filter((m) => m.status === true)
            .map((marquee, index) => (
              <span
                key={marquee.id || index}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  marginRight: "50px",
                  fontWeight: "600",
                  fontSize: "1.1rem",
                  whiteSpace: "nowrap",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                <FaStar
                  style={{
                    color: "#FFD700",
                    marginRight: "8px",
                    flexShrink: 0,
                  }}
                />
                {marquee.content?.text || marquee.content}
              </span>
            ))}
        </Marquee>
      </Container>
    </div>
  );
};

export default MarqueeBanner;
